export class Select {

  id?: string;
  text?: string;
  primary?: string
  extras?: any
  selected?: boolean
  disabled?: boolean
  /** FC-5104: added customer_id on select class for autofilling the customers
   * and to avoid going under extras property
  */
  customer_id?: string;

  constructor(id?: any, text?: string, primary?: string, extras?: any, selected?: boolean, disabled?: boolean) {
    this.id = id;
    this.text = text;
    this.extras = extras;
    this.primary = primary;
    this.selected = selected;
    this.disabled = disabled || false;
  }

}